export default __webpack_public_path__ + "static/media/55.cded2fbe.png";